<span [ngClass]="iconClass"></span>

<span *ngIf="showFormattedValue">
	{{ valueFormatted }}
</span>